import { useStoreState } from "../../../../util/util";
import { ActivityHistoryList } from "./HistoryList";
import { MainWrapper } from "./styles";
import { ActivityTargetType } from "../../../../util/activityEndpoints";
import { useActivities } from "./useActivities";

interface ActivityHistoryProps {
  targetId: string;
  targetType: ActivityTargetType;
  isTabActive?: boolean;
}

export function ActivityHistory({
  targetId,
  targetType,
  isTabActive = true,
}: ActivityHistoryProps) {
  const { tenant_id } = useStoreState();

  const {
    items,
    pages,
    error,
    isValidating,
    hasMore,
    loadMore: loadMorePage,
  } = useActivities({
    tenantId: tenant_id,
    targetId,
    targetType,
    enabled: isTabActive,
    includeDetails: false,
  });

  return (
    <MainWrapper>
      <ActivityHistoryList
        data={items}
        isLoading={pages.length === 0 && !error}
        error={error?.message}
        targetId={targetId}
        targetType={targetType}
        isTabActive={isTabActive}
        loadMore={
          hasMore
            ? {
                isLoading: isValidating && pages.length > 0,
                onLoad: loadMorePage,
              }
            : undefined
        }
      />
    </MainWrapper>
  );
}
